export const COMPANY_ROLE = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

export type CompanyRoleType = (typeof COMPANY_ROLE)[keyof typeof COMPANY_ROLE];
